import { i18n } from "./index";
import { audienceParams, audienceRoutes, supportsAudienceEndpoint } from "./audience";

let currentRoute = () => window.location.pathname;
export function setAudienceRouteReader(reader) { currentRoute = reader; }

// Used by both the default axios client and the independent DataService client.
export function applyRequestContext(config, apiBase = process.env.VUE_APP_API_URL) {
  if (!apiBase || !config.url) return config;
  let api, url;
  try {
    api = new URL(apiBase, window.location.origin);
    url = new URL(config.url, config.baseURL || api);
  } catch { return config; }
  const apiPath = api.pathname.replace(/\/$/, "") + "/api/";
  if (url.origin !== api.origin || !url.pathname.startsWith(apiPath)) return config;
  config.headers ||= {};
  config.headers["X-App-Language"] = i18n.global.locale.value;
  config.headers["Accept-Language"] = i18n.global.locale.value;
  if ((config.method || "get").toLowerCase() === "get"
    && audienceRoutes.includes(currentRoute()) && supportsAudienceEndpoint(url.href)) {
    const params = config.params instanceof URLSearchParams ? Object.fromEntries(config.params) : config.params;
    config.params = { ...params, ...audienceParams() };
  }
  return config;
}
